import { ELEMENT_TYPES, generateId, DEFAULT_PAGE_SETTINGS } from "./elements";

function makeEl(type, propsOverride = {}) {
  const def = ELEMENT_TYPES[type];
  return {
    id: generateId(),
    type,
    label: def.label,
    props: { ...JSON.parse(JSON.stringify(def.defaultProps)), ...propsOverride },
  };
}

export const STARTER_TEMPLATES = [
  {
    name: "Classic Invoice",
    description: "A clean, traditional invoice layout with all essential sections. Perfect for standard business invoices.",
    color: "#0F172A",
    sections: {
      reportHeader: [
        makeEl("twoColumn", {
          leftWidth: "45%",
          gap: 20,
          verticalAlign: "top",
          leftColumn: {
            type: "companyLogo",
            props: { src: "", ejsBinding: "", width: 160, height: 50, alignment: "left", marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 },
          },
          rightColumn: {
            type: "heading",
            props: { content: "INVOICE", ejsBinding: "", fontSize: 32, fontWeight: "bold", fontFamily: "Arial, sans-serif", textAlign: "right", color: "#0F172A", letterSpacing: 2, textTransform: "uppercase", marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 },
          },
        }),
        makeEl("divider", { color: "#0F172A", thickness: 2 }),
      ],
      pageHeader: [],
      body: [
        makeEl("twoColumn", {
          leftWidth: "55%",
          gap: 20,
          verticalAlign: "top",
          leftColumn: {
            type: "customerInfo",
            props: { title: "Bill To", fields: [{ label: "", value: "John Doe", ejsBinding: "customer.name" }, { label: "", value: "123 Main Street", ejsBinding: "customer.address" }, { label: "", value: "City, State 12345", ejsBinding: "customer.cityState" }], fontSize: 12, fontFamily: "Arial, sans-serif", titleFontSize: 13, titleFontWeight: "bold", titleColor: "#111827", color: "#374151", marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 },
          },
          rightColumn: {
            type: "invoiceDetails",
            props: { fields: [{ label: "Invoice #", value: "INV-001", ejsBinding: "invoice.number" }, { label: "Date", value: "2025-01-15", ejsBinding: "invoice.date" }, { label: "Due Date", value: "2025-02-15", ejsBinding: "invoice.dueDate" }], fontSize: 12, fontFamily: "Arial, sans-serif", labelColor: "#6B7280", valueColor: "#111827", labelWidth: 80, alignment: "right", marginTop: 0, marginBottom: 0, paddingTop: 8, paddingBottom: 8, paddingLeft: 8, paddingRight: 8 },
          },
        }),
        makeEl("spacer", { height: 8 }),
        makeEl("lineItems"),
        makeEl("totals"),
      ],
      pageFooter: [],
      reportFooter: [
        makeEl("divider"),
        makeEl("paymentTerms"),
        makeEl("footer", { content: "Thank you for your business!" }),
      ],
    },
    pageSettings: { ...DEFAULT_PAGE_SETTINGS },
  },
  {
    name: "Modern Minimal",
    description: "Sleek and minimal design with generous spacing. Great for creative agencies and modern businesses.",
    color: "#3B82F6",
    sections: {
      reportHeader: [
        makeEl("heading", { content: "INVOICE", fontSize: 36, fontWeight: "bold", color: "#3B82F6", letterSpacing: 4, textAlign: "left" }),
        makeEl("divider", { color: "#3B82F6", thickness: 3, marginBottom: 20 }),
        makeEl("companyLogo", { alignment: "left", width: 120, height: 40, marginBottom: 20 }),
        makeEl("invoiceDetails", { alignment: "left", labelColor: "#94A3B8", valueColor: "#1E293B" }),
      ],
      pageHeader: [],
      body: [
        makeEl("spacer", { height: 16 }),
        makeEl("customerInfo", { titleColor: "#3B82F6", titleFontSize: 11, titleFontWeight: "bold" }),
        makeEl("spacer", { height: 16 }),
        makeEl("lineItems", { headerBgColor: "#EFF6FF", headerTextColor: "#1E293B", borderColor: "#DBEAFE", fontSize: 11 }),
        makeEl("spacer", { height: 8 }),
        makeEl("totals", { labelColor: "#64748B", valueColor: "#1E293B" }),
      ],
      pageFooter: [],
      reportFooter: [
        makeEl("spacer", { height: 24 }),
        makeEl("paymentTerms", { fontSize: 9, color: "#94A3B8" }),
        makeEl("footer", { content: "We appreciate your business.", color: "#94A3B8", fontSize: 9 }),
      ],
    },
    pageSettings: { ...DEFAULT_PAGE_SETTINGS, marginTop: 25, marginLeft: 25, marginRight: 25 },
  },
  {
    name: "Professional",
    description: "Corporate-style with signature block, QR code, and barcode. Ideal for formal tax invoices.",
    color: "#059669",
    sections: {
      reportHeader: [
        makeEl("companyLogo", { alignment: "left", width: 180, height: 55 }),
        makeEl("heading", { content: "TAX INVOICE", fontSize: 24, color: "#059669", textAlign: "right", letterSpacing: 1 }),
        makeEl("divider", { color: "#059669", thickness: 2 }),
        makeEl("invoiceDetails", { alignment: "right", labelColor: "#6B7280", valueColor: "#111827" }),
      ],
      pageHeader: [],
      body: [
        makeEl("customerInfo", { titleColor: "#059669" }),
        makeEl("spacer", { height: 8 }),
        makeEl("lineItems", { headerBgColor: "#ECFDF5", headerTextColor: "#065F46", borderColor: "#D1FAE5" }),
        makeEl("totals", { labelColor: "#374151", valueColor: "#059669" }),
      ],
      pageFooter: [],
      reportFooter: [
        makeEl("divider", { marginTop: 16 }),
        makeEl("signature", { alignment: "right", lineWidth: 180 }),
        makeEl("spacer", { height: 16 }),
        makeEl("qrCode", { alignment: "left", size: 80 }),
        makeEl("barcode", { alignment: "right", width: 160, height: 40 }),
        makeEl("paymentTerms"),
        makeEl("footer", { content: "This is a computer-generated invoice.", color: "#9CA3AF" }),
      ],
    },
    pageSettings: { ...DEFAULT_PAGE_SETTINGS },
  },
];
